export const FractionSymbols : object = {
	'⅒' : 0.1,
	'⅑' : 0.111111111111111,
	'⅛' : 0.125,
	'⅐' : 0.142857142857143,
	'⅙' : 0.166666666666667,
	'⅕' : 0.2,
	'¼' : 0.25,
	'⅓' : 0.333333333333333,
	'⅜' : 0.375,
	'⅖' : 0.4,
	'½' : 0.5,
	'⅗' : 0.6,
	'⅝' : 0.625,
	'⅔' : 0.666666666666667,
	'¾' : 0.75,
	'⅘' : 0.8,
	'⅚' : 0.833333333333333,
	'⅞' : 0.875
};

export const NumberWords : object = {
	'one'           : 1,
	'two'           : 2,
	'three'         : 3,
	'four'          : 4,
	'five'          : 5,
	'six'           : 6,
	'seven'         : 7,
	'eight'         : 8,
	'nine'          : 9,
	'ten'           : 10,
	'eleven'        : 11,
	'twelve'        : 12,
	'thirteen'      : 13,
	'fourteen'      : 14,
	'fifteen'       : 15,
	'sixteen'       : 16,
	'seventeen'     : 17,
	'eighteen'      : 18,
	'nineteen'      : 19,
	'twenty'        : 20,
	'twenty-one'    : 21,
	'twenty-two'    : 22,
	'twenty-three'  : 23,
	'twenty-four'   : 24,
	'twenty-five'   : 25,
	'twenty-six'    : 26,
	'twenty-seven'  : 27,
	'twenty-eight'  : 28,
	'twenty-nine'   : 29,
	'thirty'        : 30,
	'thirty-one'    : 31,
	'thirty-two'    : 32,
	'thirty-three'  : 33,
	'thirty-four'   : 34,
	'thirty-five'   : 35,
	'thirty-six'    : 36,
	'thirty-seven'  : 37,
	'thirty-eight'  : 38,
	'thirty-nine'   : 39,
	'forty'         : 40,
	'forty-one'     : 41,
	'forty-two'     : 42,
	'forty-three'   : 43,
	'forty-four'    : 44,
	'forty-five'    : 45,
	'forty-six'     : 46,
	'forty-seven'   : 47,
	'forty-eight'   : 48,
	'forty-nine'    : 49,
	'fifty'         : 50,
	'fifty-one'     : 51,
	'fifty-two'     : 52,
	'fifty-three'   : 53,
	'fifty-four'    : 54,
	'fifty-five'    : 55,
	'fifty-six'     : 56,
	'fifty-seven'   : 57,
	'fifty-eight'   : 58,
	'fifty-nine'    : 59,
	'sixty'         : 60,
	'sixty-one'     : 61,
	'sixty-two'     : 62,
	'sixty-three'   : 63,
	'sixty-four'    : 64,
	'sixty-five'    : 65,
	'sixty-six'     : 66,
	'sixty-seven'   : 67,
	'sixty-eight'   : 68,
	'sixty-nine'    : 69,
	'seventy'       : 70,
	'seventy-one'   : 71,
	'seventy-two'   : 72,
	'seventy-three' : 73,
	'seventy-four'  : 74,
	'seventy-five'  : 75,
	'seventy-six'   : 76,
	'seventy-seven' : 77,
	'seventy-eight' : 78,
	'seventy-nine'  : 79,
	'eighty'        : 80,
	'eighty-one'    : 81,
	'eighty-two'    : 82,
	'eighty-three'  : 83,
	'eighty-four'   : 84,
	'eighty-five'   : 85,
	'eighty-six'    : 86,
	'eighty-seven'  : 87,
	'eighty-eight'  : 88,
	'eighty-nine'   : 89,
	'ninety'        : 90,
	'ninety-one'    : 91,
	'ninety-two'    : 92,
	'ninety-three'  : 93,
	'ninety-four'   : 94,
	'ninety-five'   : 95,
	'ninety-six'    : 96,
	'ninety-seven'  : 97,
	'ninety-eight'  : 98,
	'ninety-nine'   : 99
};

export const MeasurementAlternatives : object = {
	// volume
	'tsp'         : 'teaspoon',
	'tea spoon'   : 'teaspoon',
	'tbs'         : 'tablespoon',
	'tbl'         : 'tablespoon',
	'tbsp'        : 'tablespoon',
	'table spoon' : 'tablespoon',
	'c'           : 'cup',
	'q'           : 'quart',
	'gal'         : 'gallon',
	'ml'          : 'milliliter',
	'ltr'         : 'liter',
	'litre'       : 'liter',
	'fl oz'       : 'fluid ounce',
	'fluid oz'    : 'fluid ounce',
	'fl ounce'    : 'fluid ounce',
	// weight
	'oz'          : 'ounce',
	'lb'          : 'pound',
	'#'           : 'pound',
	'mg'          : 'milligram',
	'milligramme' : 'milligram',
	'g'           : 'gram',
	'gramme'      : 'gram',
	'kg'          : 'kilogram',
	'kilo'        : 'kilogram',
	'kilogramme'  : 'kilogram',
	// length
	'yd'          : 'yard',
	'mm'          : 'millimeter',
	'millimetre'  : 'millimeter',
	'cm'          : 'centimeter',
	'centimetre'  : 'centimeter',
	'm'           : 'meter',
	'metre'       : 'meter',
	'in'          : 'inch',
	'"'           : 'inch',
	'ft'          : 'foot',
	'feet'        : 'foot',
	// quantity
	'peice'       : 'piece',
	'pc'          : 'piece',
	'bsh'         : 'bushel',
	'loaves'      : 'loaf'
};

export const MeasurementAbbreviations : object = {
	// volume
	'teaspoon'    : 'TSP',
	'tablespoon'  : 'TBSP',
	'cup'         : 'C',
	'pint'        : 'PT',
	'quart'       : 'QT',
	'gallon'      : 'GAL',
	'milliliter'  : 'ML',
	'liter'       : 'L',
	'fluid ounce' : 'FL OZ',
	// weight
	'ounce'       : 'OZ',
	'pound'       : 'LB',
	'milligram'   : 'MG',
	'gram'        : 'G',
	'kilogram'    : 'KG',
	// length
	'millimeter'  : 'MM',
	'centimeter'  : 'CM',
	'meter'       : 'M',
	'inch'        : 'IN',
	'yard'        : 'YD',
	'foot'        : 'FT',
	// quantity
	'bushel'      : 'BSH',
	'piece'       : 'PC'
};

export const MeasurementTypes : object = {
	// volume
	'smidgen'     : 'volume',
	'dash'        : 'volume',
	'pinch'       : 'volume',
	'teaspoon'    : 'volume',
	'tablespoon'  : 'volume',
	'cup'         : 'volume',
	'pint'        : 'volume',
	'quart'       : 'volume',
	'gallon'      : 'volume',
	'milliliter'  : 'volume',
	'liter'       : 'volume',
	'fluid ounce' : 'volume',
	// weight
	'ounce'       : 'weight',
	'pound'       : 'weight',
	'milligram'   : 'weight',
	'gram'        : 'weight',
	'kilogram'    : 'weight',
	// length
	'millimeter'  : 'length',
	'centimeter'  : 'length',
	'meter'       : 'length',
	'inch'        : 'length',
	'yard'        : 'length',
	'foot'        : 'length',
	// quantity
	'part'        : 'quantity',
	'bushel'      : 'quantity',
	'head'        : 'quantity',
	'bunch'       : 'quantity',
	'thing'       : 'quantity',
	'box'         : 'quantity',
	'piece'       : 'quantity',
	'portion'     : 'quantity',
	'bit'         : 'quantity',
	'slice'       : 'quantity',
	'chunk'       : 'quantity',
	'segment'     : 'quantity',
	'section'     : 'quantity',
	'lump'        : 'quantity',
	'hunk'        : 'quantity',
	'wedge'       : 'quantity',
	'slab'        : 'quantity',
	'block'       : 'quantity',
	'brick'       : 'quantity',
	'cake'        : 'quantity',
	'bar'         : 'quantity',
	'cube'        : 'quantity',
	'stick'       : 'quantity',
	'case'        : 'quantity',
	'flat'        : 'quantity',
	'can'         : 'quantity',
	'clove'       : 'quantity',
	'loaf'        : 'quantity'
};

export const Conversions : object = {
	// use milliliter as our base measurement
	// aka measurements for each unit is for 1 ml
	// to convert from 1 measurment to another, do the following:
	// [qty] / [from measurement in 1ml] * [to measurement in 1ml]
	'volume' : {
		'milliliter'  : 1,
		'smidgen'     : 6.492288,
		'pinch'       : 3.246144,
		'dash'        : 1.623072,
		'teaspoon'    : 0.202884,
		'tablespoon'  : 0.067628,
		'cup'         : 0.00422675,
		'pint'        : 0.00211338,
		'quart'       : 0.00105669,
		'gallon'      : 0.000264172,
		'liter'       : 0.001,
		'fluid ounce' : 0.033814
	},
	'weight' : {
		'gram'      : 1,
		'milligram' : 1000,
		'ounce'     : 0.035274,
		'pound'     : 0.00220462,
		'kilogram'  : 0.001
	},
	'length' : {
		'millimeter' : 1,
		'centimeter' : 0.1,
		'meter'      : 0.001,
		'inch'       : 0.0393701,
		'yard'       : 0.00109361,
		'foot'       : 0.00328084
	}
};

export const StoreDepts : object = {
	'produce'    : 'Produce',
	'deli'       : 'Deli',
	'bakery'     : 'Bakery',
	'meat'       : 'Meat',
	'seafood'    : 'Seafood',
	'dairy'      : 'Dairy',
	'dry'        : 'Dry Goods',
	'condiments' : 'Condiments',
	'spices'     : 'Spices',
	'canned'     : 'Canned Goods',
	'frozen'     : 'Frozen Food',
	'alcohol'    : 'Alcohol',
	'beauty'     : 'Health and Beauty',
	'paper'      : 'Paper Products',
	'cleaning'   : 'Cleaning Supplies',
	'home'       : 'Home',
	'office'     : 'Office Supplies',
	'unknown'    : 'Unknown Department'
};

export const StoreDeptOrder : Array<string> = [
	'produce',
	'bakery',
	'deli',
	'meat',
	'seafood',
	'dairy',
	'dry',
	'condiments',
	'spices',
	'canned',
	'frozen',
	'alcohol',
	'beauty',
	'paper',
	'cleaning',
	'home',
	'office',
	'unknown'
];

export const ItemByDept : object = {
	// produce
	'banana'            : 'produce',
	'lettuce'           : 'produce',
	'orange'            : 'produce',
	'apricot'           : 'produce',
	'berry'             : 'produce',
	'strawberry'        : 'produce',
	'raspberry'         : 'produce',
	'blueberry'         : 'produce',
	'apple'             : 'produce',
	'onion'             : 'produce',
	'garlic'            : 'produce',
	'scallion'          : 'produce',
	'chive'             : 'produce',
	'zucchini'          : 'produce',
	'zuchini'           : 'produce',
	'cucumber'          : 'produce',
	'kale'              : 'produce',
	'arugula'           : 'produce',
	'spinach'           : 'produce',
	'mint'              : 'produce',
	'cilantro'          : 'produce',
	'dill'              : 'produce',
	'sage'              : 'produce',
	'thyme'             : 'produce',
	'marjoram'          : 'produce',
	'parsley'           : 'produce',
	'carrot'            : 'produce',
	'basil'             : 'produce',
	'mushroom'          : 'produce',
	'portobello'        : 'produce',
	'chanterelle'       : 'produce',
	'cremini'           : 'produce',
	'morel'             : 'produce',
	'enoki'             : 'produce',
	'shiitake'          : 'produce',
	'shitake'           : 'produce',
	'oyster mushroom'   : 'produce',
	'button mushroom'   : 'produce',
	'avocado'           : 'produce',
	'avo'               : 'produce',
	'avacado'           : 'produce',
	'fennel'            : 'produce',
	'cauliflower'       : 'produce',
	'broccoli'          : 'produce',
	'brussel sprout'    : 'produce',
	'brussels sprout'   : 'produce',
	'brussel'           : 'produce',
	'potato'            : 'produce',
	'potatoe'           : 'produce',
	'tomato'            : 'produce',
	'tomatoe'           : 'produce',
	'grapefruit'        : 'produce',
	'ginger'            : 'produce',
	'eggplant'          : 'produce',
	'aubergine'         : 'produce',
	'lemon'             : 'produce',
	'lime'              : 'produce',
	'squash'            : 'produce',
	'spaghetti squash'  : 'produce',
	'butternut squash'  : 'produce',
	'radish'            : 'produce',
	'chayote'           : 'produce',
	'corn'              : 'produce',
	'pineapple'         : 'produce',
	'fruit'             : 'produce',
	'grape'             : 'produce',
	'jalapeno'          : 'produce',
	'pomegranate'       : 'produce',
	'shallot'           : 'produce',
	'spring mix'        : 'produce',
	'iceburg'           : 'produce',
	'red leaf'          : 'produce',
	'tomatillo'         : 'produce',

	// bakery
	'bread'             : 'bakery',
	'toast'             : 'bakery',
	'baguette'          : 'bakery',

	// deli
	'hummus'            : 'deli',

	// meat
	'chicken'           : 'meat',
	'thigh'             : 'meat',
	'beef'              : 'meat',
	'steak'             : 'meat',
	'lamb'              : 'meat',
	'pork'              : 'meat',
	'pork chop'         : 'meat',
	'bacon'             : 'meat',
	'turkey'            : 'meat',

	// seafood
	'fish'              : 'seafood',
	'salmon'            : 'seafood',
	'tuna'              : 'seafood',
	'albacore'          : 'seafood',
	'yellowfin'         : 'seafood',
	'skipjack'          : 'seafood',
	'bluefin'           : 'seafood',
	'catfish'           : 'seafood',
	'cod'               : 'seafood',
	'sablefish'         : 'seafood',
	'bluefish'          : 'seafood',
	'bream'             : 'seafood',
	'dorade'            : 'seafood',
	'eel'               : 'seafood',
	'halibut'           : 'seafood',
	'flounder'          : 'seafood',
	'grouper'           : 'seafood',
	'mackerel'          : 'seafood',
	'monkfish'          : 'seafood',
	'skate'             : 'seafood',
	'snapper'           : 'seafood',
	'sole'              : 'seafood',
	'whitefish'         : 'seafood',
	'pollock'           : 'seafood',
	'tilapia'           : 'seafood',
	'bass'              : 'seafood',
	'swordfish'         : 'seafood',
	'shark'             : 'seafood',
	'herring'           : 'seafood',
	'haddock'           : 'seafood',
	'trout'             : 'seafood',
	'shrimp'            : 'seafood',
	'crab'              : 'seafood',
	'clam'              : 'seafood',
	'lobster'           : 'seafood',
	'oyster'            : 'seafood',

	// dairy
	'egg'               : 'dairy',
	'milk'              : 'dairy',
	'cream'             : 'dairy',
	'half and half'     : 'dairy',
	'half & half'       : 'dairy',
	'yogurt'            : 'dairy',
	'yoghurt'           : 'dairy',
	'butter'            : 'dairy',
	'margarine'         : 'dairy',
	'cheese'            : 'dairy',
	'cheddar'           : 'dairy',
	'parmesan'          : 'dairy',
	'parmesan reggiano' : 'dairy',
	'halloumi'          : 'dairy',
	'haloumi'           : 'dairy',
	'monterey jack'     : 'dairy',
	'queso panela'      : 'dairy',
	'queso'             : 'dairy',

	// dry
	'dried'             : 'dry',
	'sugar'             : 'dry',
	'granola'           : 'dry',
	'cereal'            : 'dry',
	'oatmeal'           : 'dry',
	'pasta'             : 'dry',
	'spaghetti'         : 'dry',
	'tortelinni'        : 'dry',
	'quinoa'            : 'dry',
	'lentil'            : 'dry',
	'red lentil'        : 'dry',
	'chocolate'         : 'dry',
	'rice'              : 'dry',
	'brown rice'        : 'dry',
	'wild rice'         : 'dry',
	'dry apricot'       : 'dry',
	'dried apricot'     : 'dry',
	'dried fruit'       : 'dry',

	// condiments
	'condiment'         : 'condiments',
	'sauce'             : 'condiments',
	'vinegar'           : 'condiments',
	'wine vinegar'      : 'condiments',
	'champagne vinegar' : 'condiments',
	'oil'               : 'condiments',
	'canola oil'        : 'condiments',
	'sunflower oil'     : 'condiments',
	'olive oil'         : 'condiments',
	'nut butter'        : 'condiments',
	'peanut butter'     : 'condiments',
	'almond butter'     : 'condiments',
	'cashew butter'     : 'condiments',
	'jelly'             : 'condiments',
	'strawberry jelly'  : 'condiments',
	'grape jelly'       : 'condiments',
	'raspberry jelly'   : 'condiments',
	'raspbery jelly'    : 'condiments',
	'rasberry jelly'    : 'condiments',
	'rasbery jelly'     : 'condiments',
	'raspberry jam'     : 'condiments',
	'raspbery jam'      : 'condiments',
	'rasberry jam'      : 'condiments',
	'rasbery jam'       : 'condiments',
	'jam'               : 'condiments',
	'strawberry jam'    : 'condiments',
	'ketchup'           : 'condiments',
	'catsup'            : 'condiments',
	'mustard'           : 'condiments',
	'tahini'            : 'condiments',
	'salsa'             : 'condiments',

	// spices
	'spice'             : 'spices',
	'salt'              : 'spices',
	'sea salt'          : 'spices',
	'kosher salt'       : 'spices',
	'pepper'            : 'spices',
	'black pepper'      : 'spices',
	'red pepper'        : 'spices',
	'cayenne pepper'    : 'spices',
	'pepper flake'      : 'spices',
	'chili flake'       : 'spices',
	'sweet paprika'     : 'spices',
	'spanish paprika'   : 'spices',
	'smoked paprika'    : 'spices',
	'sumac'             : 'spices',
	'cumin'             : 'spices',
	'curry'             : 'spices',
	'tajin'             : 'spices',
	'vanilla'           : 'spices',
	'zaatar'            : 'spices',

	// canned
	'canned'            : 'canned',
	'bean'              : 'canned',
	'black bean'        : 'canned',
	'canned tuna'       : 'canned',
	'canned salmon'     : 'canned',
	'pickled herring'   : 'canned',
	'anchovy'           : 'canned',
	'boquerones'        : 'canned',
	'sardine'           : 'canned',
	'hominy'            : 'canned',

	// frozen
	'frozen'            : 'frozen',
	'bagel bites'       : 'frozen',
	'frozen pizza'      : 'frozen',
	'ice cream'         : 'frozen',
	'icecream'          : 'frozen',
	'fudgecicle'        : 'frozen',
	'otter pop'         : 'frozen',

	// alcohol
	'alcohol'           : 'alcohol',
	'booze'             : 'alcohol',
	'hooch'             : 'alcohol',
	'beer'              : 'alcohol',
	'tequila'           : 'alcohol',
	'rye'               : 'alcohol',
	'whiskey'           : 'alcohol',
	'bourbon'           : 'alcohol',
	'scotch'            : 'alcohol',
	'triple sec'        : 'alcohol',
	'wine'              : 'alcohol',
	'vino'              : 'alcohol',
	'champagne'         : 'alcohol',
	'cava'              : 'alcohol',
	'prosecco'          : 'alcohol',
	'sekt'              : 'alcohol',
	'aperol'            : 'alcohol',
	'amaro'             : 'alcohol',
	'vodka'             : 'alcohol',
	'rum'               : 'alcohol',
	'rhum'              : 'alcohol',
	'gin'               : 'alcohol',
	'corona'            : 'alcohol',
	'vermouth'          : 'alcohol',
	'angostura bitter'  : 'alcohol',

	// beauty

	// paper
	'paper'             : 'paper',

	// cleaning
	'cleaner'           : 'cleaning'

	// home

	// office

	// unknown
};

export const ScaleOptions : Array<object> = [
	{
		value  : 0.25,
		title : '¼'
	}, {
		value  : 0.333333333333333,
		title : '⅓'
	}, {
		value  : 0.5,
		title : '½'
	}, {
		value  : 0.666666666666666,
		title : '⅔'
	}, {
		value  : 0.75,
		title : '¾'
	}, {
		value  : 1,
		title : 'original'
	}, {
		value  : 1.25,
		title : '1¼'
	}, {
		value  : 1.333333333333333,
		title : '1⅓'
	}, {
		value  : 1.5,
		title : '1½'
	}, {
		value  : 1.666666666666666,
		title : '1⅔'
	}, {
		value  : 1.75,
		title : '1¾'
	}, {
		value  : 2,
		title : '2x'
	}, {
		value  : 3,
		title : '3x'
	}, {
		value  : 4,
		title : '4x'
	}, {
		value  : 5,
		title : '5x'
	}, {
		value  : 8,
		title : '8x'
	}, {
		value  : 10,
		title : '10x'
	}, {
		value  : 15,
		title : '15x'
	}, {
		value  : 20,
		title : '20x'
	}, {
		value  : 25,
		title : '25x'
	}, {
		value  : 30,
		title : '30x'
	}, {
		value  : 35,
		title : '35x'
	}, {
		value  : 40,
		title : '40x'
	}, {
		value  : 45,
		title : '45x'
	}, {
		value  : 50,
		title : '50x'
	}
];

export const SortOptions : Array<object> = [
	{
		name  : 'createdAt',
		title : 'As Added'
	},
	{
		name  : 'lowercaseItem',
		title : 'Alphabetically'
	},
	{
		name  : 'dept',
		title : 'By Department'
	},
	{
		name  : 'recipe',
		title : 'By Recipe'
	}
];


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/dictionaries.ts